<div class="p-a-xl cipo-bg--white">
    <h2>Cipo Text Fields</h2>

    <div fxLayout="row wrap" fxLayoutGap="12px">
        @for (control of form().controls | keyvalue; track $index) {
            <div fxFlex="30">
                <cipo-text [control]="control.value" />
            </div>
        }
    </div>
</div>
